/**
 * @file FiltersSkeleton.tsx
 * @description
 * -----------------------------------------------------
 * Componente para el skeleton de los filtros
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-06-26
 * @author DLTCode
 * @author Ismael Benabdellah
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
interface FiltersSkeletonProps {
  filters?: number;
}
const FiltersSkeleton = t0 => {
  const $ = _c(5);
  const {
    filters: t1
  } = t0;
  const filters = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== filters) {
    t2 = Array.from({
      length: filters
    }).map(_temp);
    $[0] = filters;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="filters-skeleton--btn" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <section className="filters-skeleton">{t2}{t3}</section>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default FiltersSkeleton;
function _temp(_, idx) {
  return <section key={idx} className="filters-skeleton--text" />;
}